/**
 * @author      hugo@zumper.com (Hugo Pineda)
 * @copyright   Copyright (c) 2023, Zumper
 */

import { createLoggerInterface } from '@zcode/logger'

export const { logger, setLogger, setLogLevel } = createLoggerInterface()
